import { AppMessageBar } from "@/components/AppMessageBar";
import { FrontendAddonWithTargetVersionRaw } from "@/domain/FrontendAddon";
import React from "react";

const getNotEditableReason = (
  targetFrontendAddon: Pick<
    FrontendAddonWithTargetVersionRaw,
    "is_editable" | "is_disabled"
  >
) => {
  if (!targetFrontendAddon.is_editable) {
    return "このアドオンは複数の組織で利用されているため、編集には開発者権限が必要です。";
  }
  if (targetFrontendAddon.is_disabled) {
    return "このアドオンは無効化中のため、編集できません。";
  }
  return null;
};

export const FrontendAddonEditableNotify = ({
  targetFrontendAddon,
}: {
  targetFrontendAddon:
    | Pick<FrontendAddonWithTargetVersionRaw, "is_editable" | "is_disabled">
    | undefined;
}) => {
  const reason = targetFrontendAddon
    ? getNotEditableReason(targetFrontendAddon)
    : null;
  if (!reason) return null;
  return <AppMessageBar intent="warning" title={reason} />;
};
